import Button from 'tio-ui/components/button';
import { not } from 'tio-ui/utilities';
import { on } from '@ember/modifier';
import { t } from 'ember-intl';
import Component from '@glimmer/component';
import type { CustomFieldSignature } from '../../types/tuition-assistance.ts';
import type { TasFields } from '../../types/tuition-assistance.ts';

interface TuitionAssistanceActionButtonsSignature {
  Args: {
    cancel?: () => void;
    cancelText?: string;
    nextText?: string;
    saveAndNext?: (
      fieldsCopy: TasFields,
      customFieldsCopy: CustomFieldSignature[],
      isFormValid?: boolean
    ) => void;
    saveForLater?: (
      fieldsCopy: TasFields,
      customFieldsCopy: CustomFieldSignature[],
      isFormValid?: boolean
    ) => void;
    fieldsCopy: TasFields;
    customFieldsCopy: CustomFieldSignature[];
    isFormValid: boolean;
    saveTaskIsRunning?: boolean;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLElement;
}

export default class TuitionAssistanceActionButtonsComponent extends Component<TuitionAssistanceActionButtonsSignature> {
  onSaveAndNext = () => {
    this.args.saveAndNext?.(
      this.args.fieldsCopy,
      this.args.customFieldsCopy,
      this.args.isFormValid
    );
  };

  onSaveForLater = () => {
    this.args.saveForLater?.(
      this.args.fieldsCopy,
      this.args.customFieldsCopy,
      this.args.isFormValid
    );
  };

  <template>
    <section ...attributes>
      <div class="flex flex-col md:flex-row md:justify-center items-center gap-4">
        {{#if @cancel}}
          <Button
            @appearance="outlined"
            @intent="danger"
            {{on "click" @cancel}}
            disabled={{@saveTaskIsRunning}}
            class="mx-8 w-48"
          >
            {{if @cancelText @cancelText (t "common.cancel")}}
          </Button>
        {{/if}}

        <Button
          @intent="primary"
          {{on "click" this.onSaveAndNext}}
          disabled={{not @isFormValid}}
          @isRunning={{@saveTaskIsRunning}}
          class="mx-8 w-48"
        >
          {{if @nextText @nextText (t "common.next")}}
        </Button>
      </div>
      {{#if @saveForLater}}
        <div class="tio-flex-center">
          <Button
            @appearance="minimal"
            {{on "click" this.onSaveForLater}}
            class="text-xs tio-copy text-center my-4"
          >
            {{t "common.save_for_later"}}
          </Button>
        </div>
      {{/if}}
    </section>
  </template>
}
